// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Smart form chat panel — adapted from smartform_test */
.smart-form-panel {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}
.smart-form-panel--floating {
  position: fixed;
  z-index: 1000;
  min-width: 280px;
  min-height: 320px;
  box-shadow: 0 8px 24px rgba(26, 35, 50, 0.12), 0 2px 8px rgba(26, 35, 50, 0.08);
}
.smart-form-panel.is-resizing {
  -webkit-user-select: none;
  user-select: none;
}
.survey-panel-side {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 0.75rem;
  min-height: calc(100vh - 200px);
  position: relative;
}
.survey-panel-full {
  width: 100%;
  /* Fill the parent instead of SurveyJS's default ~708px static column. */
}
.survey-panel-full .sd-root-modern,
.survey-panel-full .sd-container-modern,
.survey-panel-full .sd-body,
.survey-panel-full .sd-body__page,
.survey-panel-full .sd-page {
  max-width: none;
  width: 100%;
}
.smart-form-panel--docked {
  position: sticky;
  top: 12rem;
  z-index: 2;
  align-self: start;
  width: 100%;
  height: min(720px, calc(100vh - 13.5rem));
  max-height: calc(100vh - 13.5rem);
  box-shadow: none;
}
.smart-form-panel--docked .chat-panel-title {
  cursor: default;
  touch-action: auto;
}
.smart-form-panel--docked .chat-panel-drag-handle,
.smart-form-panel--docked .chat-panel-resize-handle {
  display: none;
}
.smart-form-panel--docked .chat-messages {
  min-height: 0;
}
.smart-form-controls {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.35rem;
  margin-left: auto;
}
.smart-form-control {
  border: 1px solid #d9e5f2;
  border-radius: 999px;
  background: #ffffff;
  color: #07337f;
  font: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  padding: 0.3rem 0.55rem;
  cursor: pointer;
}
.smart-form-control:hover {
  border-color: #2379f4;
  color: #2379f4;
}
.chat-panel-title {
  margin: 0;
  padding: 12px 16px;
  font-size: 1.125rem;
  font-weight: 600;
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: grab;
  -webkit-user-select: none;
  user-select: none;
  touch-action: none;
  background: var(--color-bg);
}
.smart-form-panel.is-dragging .chat-panel-title {
  cursor: grabbing;
}
.chat-panel-drag-handle {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  background: radial-gradient(circle, var(--color-text-muted) 1.5px, transparent 1.5px) 0 0 / 7px 7px;
  opacity: 0.55;
}
.chat-panel-resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: nwse-resize;
  touch-action: none;
  z-index: 2;
}
.chat-panel-resize-handle::before {
  content: '';
  position: absolute;
  right: 4px;
  bottom: 4px;
  width: 10px;
  height: 10px;
  border-right: 2px solid var(--color-text-muted);
  border-bottom: 2px solid var(--color-text-muted);
  opacity: 0.55;
  border-bottom-right-radius: 2px;
}
.chat-messages {
  flex: 3;
  min-height: 0;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.chat-input-area {
  flex: 1;
  min-height: 0;
  padding: 12px 16px 16px;
  border-top: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.chat-input-area textarea {
  flex: 1;
  min-height: 60px;
  resize: none;
  width: 100%;
  padding: 12px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  font: inherit;
  font-family: inherit;
}
.chat-input-area textarea:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-light);
}
.chat-input-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.btn-secondary.listening {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
}
.status-text {
  min-height: 1.25rem;
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.85rem;
}
.chat-bubble-row {
  display: flex;
  width: 100%;
}
.chat-bubble-row.user {
  justify-content: flex-end;
}
.chat-bubble-row.assistant,
.chat-bubble-row.error,
.chat-bubble-row.loading {
  justify-content: flex-start;
}
.chat-bubble {
  max-width: 92%;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 0.95rem;
  line-height: 1.45;
}
.chat-bubble.user {
  background: var(--color-primary);
  color: #fff;
  border-bottom-right-radius: 4px;
}
.chat-bubble.assistant {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: var(--color-text);
  border-bottom-left-radius: 4px;
}
.chat-bubble.error {
  background: var(--color-error-bg);
  border: 1px solid #fecaca;
  color: var(--color-error);
  border-bottom-left-radius: 4px;
}
.chat-bubble.loading {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: var(--color-text-muted);
  border-bottom-left-radius: 4px;
}
.chat-bubble .bubble-prompt {
  margin: 0 0 8px;
}
.chat-bubble .bubble-prompt:last-child {
  margin-bottom: 0;
}
.chat-bubble .bubble-summary {
  margin: 0 0 8px;
  font-size: 0.9rem;
  color: var(--color-text-muted);
}
.chat-bubble.user .bubble-empty-start {
  font-style: italic;
  opacity: 0.9;
}
.bubble-followups {
  margin-top: 10px;
  padding: 10px;
  border-radius: var(--radius);
  background: #fffbeb;
  border: 1px solid #fde68a;
}
.bubble-followups.clarify {
  background: #fff7ed;
  border-color: #fed7aa;
}
.bubble-followups.bubble-collapsible {
  padding: 8px 10px;
}
.bubble-followups.bubble-collapsible .bubble-collapsible-toggle {
  color: #92400e;
}
.bubble-followups.clarify.bubble-collapsible .bubble-collapsible-toggle {
  color: #9a3412;
}
.bubble-followup-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.bubble-followup-item {
  margin-bottom: 6px;
}
.bubble-followup-item:last-child {
  margin-bottom: 0;
}
.bubble-followups-more {
  margin: 10px 0 0;
  font-size: 0.8rem;
  color: var(--color-text-muted);
  line-height: 1.4;
}
.bubble-followup-link {
  display: block;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.7);
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  line-height: 1.45;
  white-space: normal;
  word-break: break-word;
}
.bubble-followup-link:hover {
  background: #fff;
}
.field-badge {
  display: inline-block;
  margin-right: 6px;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  vertical-align: middle;
}
.field-badge.required {
  background: #fef2f2;
  color: #b91c1c;
}
.field-badge.clarify {
  background: #fffbeb;
  color: #b45309;
}
.bubble-updates {
  margin-top: 10px;
}
.bubble-updates.bubble-collapsible .bubble-collapsible-toggle {
  color: #047857;
}
.bubble-collapsible {
  margin-top: 10px;
}
.bubble-collapsible-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}
.bubble-collapsible-toggle:hover {
  color: #0f172a;
}
.bubble-collapsible-chevron {
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 6px solid currentColor;
  transition: transform 0.15s ease;
  flex-shrink: 0;
}
.bubble-collapsible-chevron.is-open {
  transform: rotate(90deg);
}
.bubble-collapsible-body {
  margin-top: 8px;
}
.bubble-updates-header {
  margin: 0 0 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #047857;
}
.bubble-update-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.bubble-update-chip {
  padding: 4px 10px;
  border: 1px solid #a7f3d0;
  border-radius: 999px;
  background: #ecfdf5;
  color: #065f46;
  font-size: 0.8rem;
  cursor: pointer;
  font-family: inherit;
}
.bubble-update-chip:hover {
  background: #d1fae5;
}
.bubble-requested-fields {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: var(--radius);
  padding: 8px 10px;
}
.bubble-requested-fields.bubble-collapsible {
  margin-top: 10px;
}
.bubble-requested-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.bubble-requested-chip {
  padding: 4px 10px;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1e40af;
  font-size: 0.8rem;
  cursor: pointer;
  font-family: inherit;
  line-height: 1.35;
  text-align: left;
}
.bubble-requested-chip:hover {
  background: #dbeafe;
}
.bubble-footer {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid #e2e8f0;
}
.bubble-debug-toggle {
  padding: 0;
  border: none;
  background: none;
  color: #64748b;
  font-size: 0.8rem;
  cursor: pointer;
  text-decoration: underline;
  font-family: inherit;
}
.bubble-debug-toggle:hover {
  color: #334155;
}
.bubble-debug-meta {
  margin: 0 0 8px;
  font-size: 0.75rem;
  color: #64748b;
  word-break: break-all;
}
.bubble-debug-block + .bubble-debug-block {
  margin-top: 8px;
}
.bubble-debug-block h5 {
  margin: 0 0 4px;
  font-size: 0.75rem;
  color: #475569;
}
.bubble-debug-block pre {
  margin: 0;
  padding: 8px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.7rem;
  line-height: 1.35;
  overflow: auto;
  max-height: 200px;
  white-space: pre-wrap;
  word-break: break-word;
}
.survey-panel-side .field-highlight,
.survey-container .field-highlight {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-radius: var(--radius);
  transition: outline 0.2s;
}
.chat-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid #cbd5e1;
  border-top-color: #64748b;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  vertical-align: -2px;
  margin-right: 8px;
}
@media (max-width: 960px) {
  .survey-panel-side {
    min-height: 0;
  }
}
.attachment-confirm {
  margin-top: 16px;
  padding: 16px 20px;
  border: 1px solid #bae6fd;
  background: #f0f9ff;
  border-radius: var(--radius);
}
.attachment-confirm-title {
  margin: 0 0 10px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0c4a6e;
}
.attachment-list {
  list-style: none;
  margin: 0 0 12px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.attachment-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
  color: #0f172a;
}
.attachment-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #16a34a;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  flex-shrink: 0;
}
.attachment-name {
  word-break: break-word;
}
.attachment-note {
  margin: 0;
  font-size: 0.85rem;
  color: #0c4a6e;
}
.attachment-actions {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
}
/* ── Review & submit section ── */
.submit-review {
  margin-top: 20px;
  scroll-margin-top: 96px;
}
.submit-review-title {
  margin: 0 0 12px;
  font-size: 1.1rem;
  font-weight: 600;
  color: #0f172a;
}
.review-card {
  margin-bottom: 16px;
  padding: 16px 20px;
  border: 1px solid var(--color-border, #e2e8f0);
  background: #fff;
  border-radius: var(--radius);
}
/* The attachment card keeps its blue treatment even as a review card. */
.review-card.attachment-confirm {
  margin-top: 0;
  border-color: #bae6fd;
  background: #f0f9ff;
}
.review-card-title {
  margin: 0 0 6px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
}
.review-card-note {
  margin: 0 0 14px;
  font-size: 0.85rem;
  color: var(--color-text-muted, #64748b);
}
.contact-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid var(--color-border, #e2e8f0);
  border-radius: var(--radius);
  background: #f8fafc;
}
.contact-item.is-excluded {
  opacity: 0.55;
}
.contact-include {
  display: flex;
  align-items: center;
  padding-top: 8px;
}
.contact-include input {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.contact-fields {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.contact-input {
  flex: 1 1 140px;
  min-width: 120px;
  height: 34px;
  padding: 0 10px;
  border: 1px solid var(--color-border, #cbd5e1);
  border-radius: var(--radius);
  font-size: 0.9rem;
}
.contact-note {
  flex: 0 0 auto;
  padding: 3px 10px;
  border-radius: 999px;
  background: #e0e7ff;
  color: #3730a3;
  font-size: 0.75rem;
  font-weight: 600;
}
/* ── Figma-aligned smart form experience ── */
.smart-form-panel {
  border-color: #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 10px 32px rgba(7, 51, 127, 0.12);
}
.smart-form-panel--floating {
  border-color: #c7d8eb;
  box-shadow: 0 18px 48px rgba(7, 51, 127, 0.18), 0 3px 10px rgba(7, 51, 127, 0.08);
}
.survey-panel-side {
  border-color: #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(7, 51, 127, 0.07);
}
.chat-panel-title {
  min-height: 70px;
  padding: 8px 16px;
  border-bottom-color: #d9e5f2;
  color: #07337f;
  background: linear-gradient(180deg, #f8fbff 0%, #eff6ff 100%);
  font-size: 0.95rem;
  font-weight: 700;
}
.smart-form-brand-icon-frame {
  display: inline-flex;
  width: 50px;
  height: 50px;
  flex: 0 0 50px;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  background: linear-gradient(135deg, #19f4e9 0%, #158df0 33%, #1a5fcc 67%, #220f8e 100%);
  box-shadow: 0 5px 12px rgba(7, 51, 127, 0.18);
}
.smart-form-brand-icon {
  position: relative;
  display: inline-flex;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
  border-radius: 40px;
  background: linear-gradient(135deg, #19f4e9 10%, #158df0 63%, #1a5fcc 67%, #220f8e 100%);
}
.smart-form-brand-owl {
  position: absolute;
  top: -18%;
  left: 50%;
  width: auto;
  max-width: none;
  height: 140%;
  object-fit: contain;
  transform: translateX(-40%) translateY(20%);
}
.smart-form-brand-star {
  position: absolute;
  z-index: 1;
  display: block;
  height: auto;
  pointer-events: none;
}
.smart-form-brand-star--large {
  top: 10px;
  left: -1px;
  width: 10px;
}
.smart-form-brand-star--small {
  top: 17px;
  left: 6px;
  width: 6px;
  opacity: 0.9;
}
.smart-form-title-copy {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 2px;
}
.smart-form-title-text {
  color: #07337f;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.25;
}
.smart-form-title-description {
  max-width: 460px;
  color: #68788e;
  font-size: 0.72rem;
  font-weight: 400;
  line-height: 1.35;
}
.chat-panel-drag-handle {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  opacity: 0.65;
  background: radial-gradient(circle, #2379f4 1.5px, transparent 1.5px) 0 0 / 7px 7px;
}
.chat-messages {
  gap: 14px;
  padding: 18px 16px;
  background: #f8fbff;
}
.chat-input-area {
  gap: 10px;
  padding: 14px 16px 16px;
  border-top-color: #d9e5f2;
  background: #ffffff;
}
.chat-input-area textarea {
  width: auto;
  min-width: 0;
  min-height: 42px;
  height: 100%;
  padding: 9px 11px;
  border-color: #c6d5e5;
  border-radius: 6px;
  color: #1d2b3c;
  background: #fff;
}
.chat-input-area textarea:focus {
  border-color: #2379f4;
  box-shadow: 0 0 0 3px rgba(35, 121, 244, 0.15);
}
.chat-compose-row {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
  height: 100%;
}
.microphone-button {
  width: 42px;
  min-width: 42px;
  height: 42px;
  min-height: 42px;
  padding: 0 !important;
  align-items: center;
  justify-content: center;
}
.microphone-icon {
  width: 19px;
  height: 19px;
}
.submit-icon-button {
  width: 42px;
  min-width: 42px;
  height: 42px;
  min-height: 42px;
  margin-left: auto;
  padding: 0 !important;
  align-items: center;
  justify-content: center;
}
.submit-icon {
  width: 19px;
  height: 19px;
}
.status-text {
  color: #68788e;
}
.chat-bubble {
  max-width: 92%;
  padding: 11px 13px;
  border-radius: 11px;
  color: #1d2b3c;
  font-size: 0.84rem;
  line-height: 1.48;
}
.chat-bubble.user {
  color: #fff;
  background: #2379f4;
  border-bottom-right-radius: 3px;
  box-shadow: 0 4px 12px rgba(35, 121, 244, 0.16);
}
.chat-bubble.assistant {
  border: 1px solid #d9e5f2;
  border-bottom-left-radius: 3px;
  background: #ffffff;
  box-shadow: 0 3px 10px rgba(7, 51, 127, 0.06);
}
.chat-bubble.error {
  border-color: #ffc8cf;
  color: #a92032;
  background: #fff1f3;
}
.chat-bubble.loading {
  border: 1px solid #d9e5f2;
  background: #ffffff;
}
.bubble-followups,
.bubble-updates,
.bubble-requested-fields {
  border-color: #d9e5f2;
  border-radius: 6px;
  background: #f7faff;
}
.bubble-followup-link,
.bubble-collapsible-toggle {
  color: #2379f4;
}
.bubble-followup-link:hover,
.bubble-collapsible-toggle:hover {
  color: #1267dc;
}
.field-badge,
.bubble-update-chip,
.bubble-requested-chip {
  border-color: #c8d9ed;
  border-radius: 999px;
  color: #31557f;
  background: #edf5ff;
}
.field-badge.required {
  border-color: #ffd2d8;
  color: #b72b3e;
  background: #fff0f2;
}
.field-badge.clarify {
  border-color: #f8db9c;
  color: #8b5a08;
  background: #fff8e8;
}
.bubble-debug-toggle {
  color: #68788e;
}
.bubble-debug-toggle:hover {
  color: #2379f4;
}
.bubble-debug-panel,
.bubble-debug-block pre {
  border: 1px solid #d9e5f2;
  border-radius: 6px;
  background: #f5f8fc;
}
.survey-panel-side .sd-root-modern {
  --sjs-primary-backcolor: #2379f4;
  --sjs-primary-backcolor-dark: #1267dc;
  --sjs-primary-backcolor-light: #e9f3ff;
  --sjs-general-backcolor: #ffffff;
  --sjs-general-forecolor: #1d2b3c;
  --sjs-secondary-backcolor: #edf7ff;
  --sjs-border-default: #d9e5f2;
  --sjs-font-family: var(--font);
  --sjs-base-unit: 6px;
  --sd-base-padding: 5px;
  --sd-base-vertical-padding: 8px;
  --sd-page-vertical-padding: 8px;
}
.survey-panel-side .field-highlight {
  outline-color: #2379f4;
  box-shadow: 0 0 0 4px rgba(35, 121, 244, 0.12);
}
.submit-review {
  margin-top: 24px;
}
.submit-review-title {
  color: #1d2b3c;
  font-size: 1.05rem;
}
.review-card {
  border-color: #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 5px 18px rgba(7, 51, 127, 0.05);
}
.contact-item {
  border-color: #d9e5f2;
  border-radius: 6px;
  background: #f8fbff;
}
.contact-input {
  border-color: #c5d4e4;
  border-radius: 6px;
}
.contact-input:focus {
  outline: none;
  border-color: #2379f4;
  box-shadow: 0 0 0 3px rgba(35, 121, 244, 0.14);
}
.contact-note {
  color: #225c9b;
  background: #e5f1ff;
}
.attachment-confirm,
.review-card.attachment-confirm {
  border-color: #b7d7f7;
  border-radius: 10px;
  background: #eef7ff;
}
.attachment-confirm-title,
.attachment-note {
  color: #07337f;
}
.attachment-check {
  background: #18833d;
}
@media (max-width: 960px) {
  .smart-form-panel--floating {
    position: relative !important;
    inset: auto !important;
    width: 100% !important;
    height: min(560px, 72vh) !important;
    min-width: 0;
    margin-bottom: 1rem;
  }
  .chat-panel-title {
    cursor: default;
  }
  .chat-panel-drag-handle,
  .chat-panel-resize-handle {
    display: none;
  }
  .survey-panel-side {
    padding: 0.5rem;
  }
}
@media (max-width: 600px) {
  .smart-form-panel--floating {
    height: min(500px, 68vh) !important;
  }
  .chat-compose-row {
    gap: 6px;
  }
  .contact-item {
    gap: 8px;
  }
  .contact-fields {
    display: grid;
    grid-template-columns: 1fr;
  }
  .contact-input {
    width: 100%;
    min-width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/smart-form.less"],"names":[],"mappings":"AAAA,wDAAwD;AAaxD;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;AAXF;AAcA;EACE,eAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,+EAAA;AAZF;AAiBA;EACE,yBAAA;EACA,iBAAA;AAfF;AAkBA;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;AAhBF;AAmBA;EACE,WAAA;EAjBA,wEAAwE;AAC1E;AAeA;;;;;EASI,eAAA;EACA,WAAA;AAjBJ;AAqBA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,yCAAA;EACA,iCAAA;EACA,gBAAA;AAnBF;AAWA;EAWI,eAAA;EACA,kBAAA;AAnBJ;AAOA;;EAiBI,aAAA;AApBJ;AAGA;EAqBI,aAAA;AArBJ;AAyBA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAvBF;AA0BA;EACE,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;AAxBF;AA0BE;EACE,qBAAA;EACA,cAAA;AAxBJ;AA4BA;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;AA1BF;AA6BA;EACE,gBAAA;AA3BF;AA8BA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mGAAA;EAEA,aAAA;AA7BF;AAgCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AA9BF;AAiCA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,+CAAA;EACA,gDAAA;EACA,aAAA;EACA,+BAAA;AA/BF;AAkCA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAhCF;AAmCA;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAjCF;AAoCA;EACE,OAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,4BAAA;EACA,aAAA;EACA,oBAAA;AAlCF;AAqCA;EACE,aAAA;EACA,kCAAA;EACA,gDAAA;AAnCF;AAsCA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AApCF;AAuCA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AArCF;AAwCA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAtCF;AAyCA;EACE,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,kBAAA;AAvCF;AA0CA;EACE,aAAA;EACA,WAAA;AAxCF;AA2CA;EACE,yBAAA;AAzCF;AA4CA;;;EAGE,2BAAA;AA1CF;AA6CA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AA3CF;AA8CA;EACE,gCAAA;EACA,WAAA;EACA,+BAAA;AA5CF;AA+CA;EACE,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,8BAAA;AA7CF;AAgDA;EACE,iCAAA;EACA,yBAAA;EACA,yBAAA;EACA,8BAAA;AA9CF;AAiDA;EACE,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,8BAAA;AA/CF;AAkDA;EACE,eAAA;AAhDF;AAmDA;EACE,gBAAA;AAjDF;AAoDA;EACE,eAAA;EACA,iBAAA;EACA,8BAAA;AAlDF;AAqDA;EACE,kBAAA;EACA,YAAA;AAnDF;AAsDA;EACE,gBAAA;EACA,aAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;AApDF;AAuDA;EACE,mBAAA;EACA,qBAAA;AArDF;AAwDA;EACE,iBAAA;AAtDF;AAyDA;EACE,cAAA;AAvDF;AA0DA;EACE,cAAA;AAxDF;AA2DA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AAzDF;AA4DA;EACE,kBAAA;AA1DF;AA6DA;EACE,gBAAA;AA3DF;AA8DA;EACE,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,gBAAA;AA5DF;AA+DA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;AA7DF;AAgEA;EACE,gBAAA;AA9DF;AAiEA;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AA/DF;AAkEA;EACE,mBAAA;EACA,cAAA;AAhEF;AAmEA;EACE,mBAAA;EACA,cAAA;AAjEF;AAoEA;EACE,gBAAA;AAlEF;AAqEA;EACE,cAAA;AAnEF;AAsEA;EACE,gBAAA;AApEF;AAuEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AArEF;AAwEA;EACE,cAAA;AAtEF;AAyEA;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;EACA,mCAAA;EACA,gCAAA;EACA,cAAA;AAvEF;AA0EA;EACE,wBAAA;AAxEF;AA2EA;EACE,eAAA;AAzEF;AA4EA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA1EF;AA6EA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA3EF;AA8EA;EACE,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AA5EF;AA+EA;EACE,mBAAA;AA7EF;AAgFA;EACE,mBAAA;EACA,yBAAA;EACA,4BAAA;EACA,iBAAA;AA9EF;AAiFA;EACE,gBAAA;AA/EF;AAkFA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAhFF;AAmFA;EACE,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;AAjFF;AAoFA;EACE,mBAAA;AAlFF;AAqFA;EACE,gBAAA;EACA,gBAAA;EACA,6BAAA;AAnFF;AAsFA;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,0BAAA;EACA,oBAAA;AApFF;AAuFA;EACE,cAAA;AArFF;AAwFA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AAtFF;AAyFA;EACE,eAAA;AAvFF;AA0FA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AAxFF;AA2FA;EACE,SAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAzFF;AA4FA;;EAEE,uCAAA;EACA,mBAAA;EACA,4BAAA;EACA,wBAAA;AA1FF;AA6FA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,oBAAA;EACA,iBAAA;AA3FF;AA8FA;EACE;IACE,aAAA;EA5FF;AACF;AA+FA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;AA7FF;AAgGA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA9FF;AAiGA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA/FF;AAkGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAhGF;AAmGA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAjGF;AAoGA;EACE,sBAAA;AAlGF;AAqGA;EACE,SAAA;EACA,kBAAA;EACA,cAAA;AAnGF;AAsGA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;AApGF;AACA,kCAAkC;AAwGlC;EACE,gBAAA;EACA,uBAAA;AAtGF;AAyGA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAvGF;AA0GA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EACA,gBAAA;EACA,4BAAA;AAxGF;AACA,wEAAwE;AA2GxE;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AAzGF;AA4GA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA1GF;AA6GA;EACE,gBAAA;EACA,kBAAA;EACA,uCAAA;AA3GF;AA8GA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA5GF;AA+GA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,8CAAA;EACA,4BAAA;EACA,mBAAA;AA7GF;AAgHA;EACE,aAAA;AA9GF;AAiHA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA/GF;AAkHA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAhHF;AAmHA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;AAjHF;AAoHA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,8CAAA;EACA,4BAAA;EACA,iBAAA;AAlHF;AAqHA;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAnHF;AACA,8CAA8C;AAuH9C;EACE,qBAAA;EACA,mBAAA;EACA,8CAAA;AArHF;AAwHA;EACE,qBAAA;EACA,iFAAA;AAtHF;AA2HA;EACE,qBAAA;EACA,mBAAA;EACA,6CAAA;AAzHF;AA4HA;EACE,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,6DAAA;EACA,kBAAA;EACA,gBAAA;AA1HF;AA6HA;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uFAAA;EACA,6CAAA;AA3HF;AA8HA;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wFAAA;AA5HF;AA+HA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;AA7HF;AAgIA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;AA9HF;AAiIA;EACE,SAAA;EACA,UAAA;EACA,WAAA;AA/HF;AAkIA;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AAhIF;AAmIA;EACE,aAAA;EACA,YAAA;EACA,OAAA;EACA,sBAAA;EACA,QAAA;AAjIF;AAoIA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAlIF;AAqIA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAnIF;AAsIA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mFAAA;AApIF;AAwIA;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;AAtIF;AAyIA;EACE,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;AAvIF;AAmIA;EAOI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAvIJ;AAyII;EACE,qBAAA;EACA,8CAAA;AAvIN;AA4IA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AA1IF;AA6IA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AA3IF;AA8IA;EACE,WAAA;EACA,YAAA;AA5IF;AA+IA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AA7IF;AAgJA;EACE,WAAA;EACA,YAAA;AA9IF;AAiJA;EACE,cAAA;AA/IF;AAkJA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AAhJF;AAkJE;EACE,WAAA;EACA,mBAAA;EACA,+BAAA;EACA,+CAAA;AAhJJ;AAmJE;EACE,yBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6CAAA;AAjJJ;AAoJE;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;AAlJJ;AAqJE;EACE,yBAAA;EACA,mBAAA;AAnJJ;AAuJA;;;EAGE,qBAAA;EACA,kBAAA;EACA,mBAAA;AArJF;AAwJA;;EAEE,cAAA;AAtJF;AAwJE;;EACE,cAAA;AArJJ;AAyJA;;;EAGE,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;AAvJF;AA0JA;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;AAxJF;AA2JA;EACE,qBAAA;EACA,cAAA;EACA,mBAAA;AAzJF;AA4JA;EACE,cAAA;AA1JF;AA4JE;EACE,cAAA;AA1JJ;AA8JA;;EAEE,yBAAA;EACA,kBAAA;EACA,mBAAA;AA5JF;AA+JA;EAEI,gCAAA;EACA,qCAAA;EACA,sCAAA;EACA,gCAAA;EACA,gCAAA;EACA,kCAAA;EACA,6BAAA;EACA,8BAAA;EACA,oBAAA;EACA,sBAAA;EACA,+BAAA;EACA,+BAAA;AA9JJ;AAiJA;EAiBI,sBAAA;EACA,8CAAA;AA/JJ;AAmKA;EACE,gBAAA;AAjKF;AAoKA;EACE,cAAA;EACA,kBAAA;AAlKF;AAqKA;EACE,qBAAA;EACA,mBAAA;EACA,6CAAA;AAnKF;AAsKA;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;AApKF;AAuKA;EACE,qBAAA;EACA,kBAAA;AArKF;AAuKE;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AArKJ;AAyKA;EACE,cAAA;EACA,mBAAA;AAvKF;AA0KA;;EAEE,qBAAA;EACA,mBAAA;EACA,mBAAA;AAxKF;AA2KA;;EAEE,cAAA;AAzKF;AA4KA;EACE,mBAAA;AA1KF;AA6KA;EACE;IACE,6BAAA;IACA,sBAAA;IACA,sBAAA;IACA,mCAAA;IACA,YAAA;IACA,mBAAA;EA3KF;EA8KA;IACE,eAAA;EA5KF;EA+KA;;IAEE,aAAA;EA7KF;EAgLA;IACE,eAAA;EA9KF;AACF;AAiLA;EACE;IACE,mCAAA;EA/KF;EAkLA;IACE,QAAA;EAhLF;EAmLA;IACE,QAAA;EAjLF;EAoLA;IACE,aAAA;IACA,0BAAA;EAlLF;EAqLA;IACE,WAAA;IACA,YAAA;EAnLF;AACF","sourcesContent":["/* Smart form chat panel — adapted from smartform_test */\n\n@primary: #2379f4;\n@primary-hover: #1267dc;\n@navy: #07337f;\n@border: #d9e5f2;\n@text: #1d2b3c;\n@muted: #68788e;\n@sky: #edf7ff;\n@surface: #ffffff;\n@radius: 6px;\n@radius-lg: 10px;\n\n.smart-form-panel {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow);\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  overflow: hidden;\n}\n\n.smart-form-panel--floating {\n  position: fixed;\n  z-index: 1000;\n  min-width: 280px;\n  min-height: 320px;\n  box-shadow:\n    0 8px 24px rgba(26, 35, 50, 0.12),\n    0 2px 8px rgba(26, 35, 50, 0.08);\n}\n\n.smart-form-panel.is-resizing {\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.survey-panel-side {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: 0.75rem;\n  min-height: calc(100vh - 200px);\n  position: relative;\n}\n\n.survey-panel-full {\n  width: 100%;\n\n  /* Fill the parent instead of SurveyJS's default ~708px static column. */\n  .sd-root-modern,\n  .sd-container-modern,\n  .sd-body,\n  .sd-body__page,\n  .sd-page {\n    max-width: none;\n    width: 100%;\n  }\n}\n\n.smart-form-panel--docked {\n  position: sticky;\n  top: 12rem;\n  z-index: 2;\n  align-self: start;\n  width: 100%;\n  height: min(720px, calc(100vh - 13.5rem));\n  max-height: calc(100vh - 13.5rem);\n  box-shadow: none;\n\n  .chat-panel-title {\n    cursor: default;\n    touch-action: auto;\n  }\n\n  .chat-panel-drag-handle,\n  .chat-panel-resize-handle {\n    display: none;\n  }\n\n  .chat-messages {\n    min-height: 0;\n  }\n}\n\n.smart-form-controls {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 0.35rem;\n  margin-left: auto;\n}\n\n.smart-form-control {\n  border: 1px solid @border;\n  border-radius: 999px;\n  background: @surface;\n  color: @navy;\n  font: inherit;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1;\n  padding: 0.3rem 0.55rem;\n  cursor: pointer;\n\n  &:hover {\n    border-color: @primary;\n    color: @primary;\n  }\n}\n\n.chat-panel-title {\n  margin: 0;\n  padding: 12px 16px;\n  font-size: 1.125rem;\n  font-weight: 600;\n  border-bottom: 1px solid var(--color-border);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: grab;\n  -webkit-user-select: none;\n  user-select: none;\n  touch-action: none;\n  background: var(--color-bg);\n}\n\n.smart-form-panel.is-dragging .chat-panel-title {\n  cursor: grabbing;\n}\n\n.chat-panel-drag-handle {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n  background:\n    radial-gradient(circle, var(--color-text-muted) 1.5px, transparent 1.5px) 0 0 / 7px 7px;\n  opacity: 0.55;\n}\n\n.chat-panel-resize-handle {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: nwse-resize;\n  touch-action: none;\n  z-index: 2;\n}\n\n.chat-panel-resize-handle::before {\n  content: '';\n  position: absolute;\n  right: 4px;\n  bottom: 4px;\n  width: 10px;\n  height: 10px;\n  border-right: 2px solid var(--color-text-muted);\n  border-bottom: 2px solid var(--color-text-muted);\n  opacity: 0.55;\n  border-bottom-right-radius: 2px;\n}\n\n.chat-messages {\n  flex: 3;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.chat-input-area {\n  flex: 1;\n  min-height: 0;\n  padding: 12px 16px 16px;\n  border-top: 1px solid var(--color-border);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.chat-input-area textarea {\n  flex: 1;\n  min-height: 60px;\n  resize: none;\n  width: 100%;\n  padding: 12px;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  font: inherit;\n  font-family: inherit;\n}\n\n.chat-input-area textarea:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px var(--color-primary-light);\n}\n\n.chat-input-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.btn-secondary.listening {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n.status-text {\n  min-height: 1.25rem;\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.85rem;\n}\n\n.chat-bubble-row {\n  display: flex;\n  width: 100%;\n}\n\n.chat-bubble-row.user {\n  justify-content: flex-end;\n}\n\n.chat-bubble-row.assistant,\n.chat-bubble-row.error,\n.chat-bubble-row.loading {\n  justify-content: flex-start;\n}\n\n.chat-bubble {\n  max-width: 92%;\n  padding: 10px 14px;\n  border-radius: 12px;\n  font-size: 0.95rem;\n  line-height: 1.45;\n}\n\n.chat-bubble.user {\n  background: var(--color-primary);\n  color: #fff;\n  border-bottom-right-radius: 4px;\n}\n\n.chat-bubble.assistant {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  color: var(--color-text);\n  border-bottom-left-radius: 4px;\n}\n\n.chat-bubble.error {\n  background: var(--color-error-bg);\n  border: 1px solid #fecaca;\n  color: var(--color-error);\n  border-bottom-left-radius: 4px;\n}\n\n.chat-bubble.loading {\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  color: var(--color-text-muted);\n  border-bottom-left-radius: 4px;\n}\n\n.chat-bubble .bubble-prompt {\n  margin: 0 0 8px;\n}\n\n.chat-bubble .bubble-prompt:last-child {\n  margin-bottom: 0;\n}\n\n.chat-bubble .bubble-summary {\n  margin: 0 0 8px;\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n}\n\n.chat-bubble.user .bubble-empty-start {\n  font-style: italic;\n  opacity: 0.9;\n}\n\n.bubble-followups {\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: var(--radius);\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n}\n\n.bubble-followups.clarify {\n  background: #fff7ed;\n  border-color: #fed7aa;\n}\n\n.bubble-followups.bubble-collapsible {\n  padding: 8px 10px;\n}\n\n.bubble-followups.bubble-collapsible .bubble-collapsible-toggle {\n  color: #92400e;\n}\n\n.bubble-followups.clarify.bubble-collapsible .bubble-collapsible-toggle {\n  color: #9a3412;\n}\n\n.bubble-followup-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.bubble-followup-item {\n  margin-bottom: 6px;\n}\n\n.bubble-followup-item:last-child {\n  margin-bottom: 0;\n}\n\n.bubble-followups-more {\n  margin: 10px 0 0;\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n  line-height: 1.4;\n}\n\n.bubble-followup-link {\n  display: block;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.7);\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  line-height: 1.45;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.bubble-followup-link:hover {\n  background: #fff;\n}\n\n.field-badge {\n  display: inline-block;\n  margin-right: 6px;\n  padding: 1px 6px;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  vertical-align: middle;\n}\n\n.field-badge.required {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.field-badge.clarify {\n  background: #fffbeb;\n  color: #b45309;\n}\n\n.bubble-updates {\n  margin-top: 10px;\n}\n\n.bubble-updates.bubble-collapsible .bubble-collapsible-toggle {\n  color: #047857;\n}\n\n.bubble-collapsible {\n  margin-top: 10px;\n}\n\n.bubble-collapsible-toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #334155;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n}\n\n.bubble-collapsible-toggle:hover {\n  color: #0f172a;\n}\n\n.bubble-collapsible-chevron {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 6px solid currentColor;\n  transition: transform 0.15s ease;\n  flex-shrink: 0;\n}\n\n.bubble-collapsible-chevron.is-open {\n  transform: rotate(90deg);\n}\n\n.bubble-collapsible-body {\n  margin-top: 8px;\n}\n\n.bubble-updates-header {\n  margin: 0 0 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #047857;\n}\n\n.bubble-update-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.bubble-update-chip {\n  padding: 4px 10px;\n  border: 1px solid #a7f3d0;\n  border-radius: 999px;\n  background: #ecfdf5;\n  color: #065f46;\n  font-size: 0.8rem;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.bubble-update-chip:hover {\n  background: #d1fae5;\n}\n\n.bubble-requested-fields {\n  background: #f8fafc;\n  border: 1px solid #cbd5e1;\n  border-radius: var(--radius);\n  padding: 8px 10px;\n}\n\n.bubble-requested-fields.bubble-collapsible {\n  margin-top: 10px;\n}\n\n.bubble-requested-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.bubble-requested-chip {\n  padding: 4px 10px;\n  border: 1px solid #bfdbfe;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1e40af;\n  font-size: 0.8rem;\n  cursor: pointer;\n  font-family: inherit;\n  line-height: 1.35;\n  text-align: left;\n}\n\n.bubble-requested-chip:hover {\n  background: #dbeafe;\n}\n\n.bubble-footer {\n  margin-top: 10px;\n  padding-top: 8px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.bubble-debug-toggle {\n  padding: 0;\n  border: none;\n  background: none;\n  color: #64748b;\n  font-size: 0.8rem;\n  cursor: pointer;\n  text-decoration: underline;\n  font-family: inherit;\n}\n\n.bubble-debug-toggle:hover {\n  color: #334155;\n}\n\n.bubble-debug-meta {\n  margin: 0 0 8px;\n  font-size: 0.75rem;\n  color: #64748b;\n  word-break: break-all;\n}\n\n.bubble-debug-block + .bubble-debug-block {\n  margin-top: 8px;\n}\n\n.bubble-debug-block h5 {\n  margin: 0 0 4px;\n  font-size: 0.75rem;\n  color: #475569;\n}\n\n.bubble-debug-block pre {\n  margin: 0;\n  padding: 8px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  line-height: 1.35;\n  overflow: auto;\n  max-height: 200px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.survey-panel-side .field-highlight,\n.survey-container .field-highlight {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n  border-radius: var(--radius);\n  transition: outline 0.2s;\n}\n\n.chat-spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid #cbd5e1;\n  border-top-color: #64748b;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  vertical-align: -2px;\n  margin-right: 8px;\n}\n\n@media (max-width: 960px) {\n  .survey-panel-side {\n    min-height: 0;\n  }\n}\n\n.attachment-confirm {\n  margin-top: 16px;\n  padding: 16px 20px;\n  border: 1px solid #bae6fd;\n  background: #f0f9ff;\n  border-radius: var(--radius);\n}\n\n.attachment-confirm-title {\n  margin: 0 0 10px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #0c4a6e;\n}\n\n.attachment-list {\n  list-style: none;\n  margin: 0 0 12px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.attachment-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.9rem;\n  color: #0f172a;\n}\n\n.attachment-check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #16a34a;\n  color: #fff;\n  font-size: 0.7rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.attachment-name {\n  word-break: break-word;\n}\n\n.attachment-note {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #0c4a6e;\n}\n\n.attachment-actions {\n  margin-top: 14px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* ── Review & submit section ── */\n\n.submit-review {\n  margin-top: 20px;\n  scroll-margin-top: 96px;\n}\n\n.submit-review-title {\n  margin: 0 0 12px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.review-card {\n  margin-bottom: 16px;\n  padding: 16px 20px;\n  border: 1px solid var(--color-border, #e2e8f0);\n  background: #fff;\n  border-radius: var(--radius);\n}\n\n/* The attachment card keeps its blue treatment even as a review card. */\n.review-card.attachment-confirm {\n  margin-top: 0;\n  border-color: #bae6fd;\n  background: #f0f9ff;\n}\n\n.review-card-title {\n  margin: 0 0 6px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.review-card-note {\n  margin: 0 0 14px;\n  font-size: 0.85rem;\n  color: var(--color-text-muted, #64748b);\n}\n\n.contact-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.contact-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 12px;\n  border: 1px solid var(--color-border, #e2e8f0);\n  border-radius: var(--radius);\n  background: #f8fafc;\n}\n\n.contact-item.is-excluded {\n  opacity: 0.55;\n}\n\n.contact-include {\n  display: flex;\n  align-items: center;\n  padding-top: 8px;\n}\n\n.contact-include input {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.contact-fields {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.contact-input {\n  flex: 1 1 140px;\n  min-width: 120px;\n  height: 34px;\n  padding: 0 10px;\n  border: 1px solid var(--color-border, #cbd5e1);\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n}\n\n.contact-note {\n  flex: 0 0 auto;\n  padding: 3px 10px;\n  border-radius: 999px;\n  background: #e0e7ff;\n  color: #3730a3;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n/* ── Figma-aligned smart form experience ── */\n\n.smart-form-panel {\n  border-color: @border;\n  border-radius: @radius-lg;\n  box-shadow: 0 10px 32px fade(@navy, 12%);\n}\n\n.smart-form-panel--floating {\n  border-color: #c7d8eb;\n  box-shadow:\n    0 18px 48px fade(@navy, 18%),\n    0 3px 10px fade(@navy, 8%);\n}\n\n.survey-panel-side {\n  border-color: @border;\n  border-radius: @radius-lg;\n  box-shadow: 0 8px 28px fade(@navy, 7%);\n}\n\n.chat-panel-title {\n  min-height: 70px;\n  padding: 8px 16px;\n  border-bottom-color: @border;\n  color: @navy;\n  background: linear-gradient(180deg, #f8fbff 0%, #eff6ff 100%);\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.smart-form-brand-icon-frame {\n  display: inline-flex;\n  width: 50px;\n  height: 50px;\n  flex: 0 0 50px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50px;\n  background: linear-gradient(135deg, #19f4e9 0%, #158df0 33%, #1a5fcc 67%, #220f8e 100%);\n  box-shadow: 0 5px 12px fade(@navy, 18%);\n}\n\n.smart-form-brand-icon {\n  position: relative;\n  display: inline-flex;\n  width: 40px;\n  height: 40px;\n  flex: 0 0 40px;\n  align-items: flex-end;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 40px;\n  background: linear-gradient(135deg, #19f4e9 10%, #158df0 63%, #1a5fcc 67%, #220f8e 100%)\n}\n\n.smart-form-brand-owl {\n  position: absolute;\n  top: -18%;\n  left: 50%;\n  width: auto;\n  max-width: none;\n  height: 140%;\n  object-fit: contain;\n  transform: translateX(-40%) translateY(20%);\n}\n\n.smart-form-brand-star {\n  position: absolute;\n  z-index: 1;\n  display: block;\n  height: auto;\n  pointer-events: none;\n}\n\n.smart-form-brand-star--large {\n  top: 10px;\n  left: -1px;\n  width: 10px;\n}\n\n.smart-form-brand-star--small {\n  top: 17px;\n  left: 6px;\n  width: 6px;\n  opacity: 0.9;\n}\n\n.smart-form-title-copy {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.smart-form-title-text {\n  color: @navy;\n  font-size: 0.95rem;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.smart-form-title-description {\n  max-width: 460px;\n  color: @muted;\n  font-size: 0.72rem;\n  font-weight: 400;\n  line-height: 1.35;\n}\n\n.chat-panel-drag-handle {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  opacity: 0.65;\n  background:\n    radial-gradient(circle, @primary 1.5px, transparent 1.5px) 0 0 / 7px 7px;\n}\n\n.chat-messages {\n  gap: 14px;\n  padding: 18px 16px;\n  background: #f8fbff;\n}\n\n.chat-input-area {\n  gap: 10px;\n  padding: 14px 16px 16px;\n  border-top-color: @border;\n  background: @surface;\n\n  textarea {\n    width: auto;\n    min-width: 0;\n    min-height: 42px;\n    height: 100%;\n    padding: 9px 11px;\n    border-color: #c6d5e5;\n    border-radius: @radius;\n    color: @text;\n    background: #fff;\n\n    &:focus {\n      border-color: @primary;\n      box-shadow: 0 0 0 3px fade(@primary, 15%);\n    }\n  }\n}\n\n.chat-compose-row {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 8px;\n  height: 100%;\n}\n\n.microphone-button {\n  width: 42px;\n  min-width: 42px;\n  height: 42px;\n  min-height: 42px;\n  padding: 0 !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.microphone-icon {\n  width: 19px;\n  height: 19px;\n}\n\n.submit-icon-button {\n  width: 42px;\n  min-width: 42px;\n  height: 42px;\n  min-height: 42px;\n  margin-left: auto;\n  padding: 0 !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.submit-icon {\n  width: 19px;\n  height: 19px;\n}\n\n.status-text {\n  color: @muted;\n}\n\n.chat-bubble {\n  max-width: 92%;\n  padding: 11px 13px;\n  border-radius: 11px;\n  color: @text;\n  font-size: 0.84rem;\n  line-height: 1.48;\n\n  &.user {\n    color: #fff;\n    background: @primary;\n    border-bottom-right-radius: 3px;\n    box-shadow: 0 4px 12px fade(@primary, 16%);\n  }\n\n  &.assistant {\n    border: 1px solid @border;\n    border-bottom-left-radius: 3px;\n    background: @surface;\n    box-shadow: 0 3px 10px fade(@navy, 6%);\n  }\n\n  &.error {\n    border-color: #ffc8cf;\n    color: #a92032;\n    background: #fff1f3;\n  }\n\n  &.loading {\n    border: 1px solid @border;\n    background: @surface;\n  }\n}\n\n.bubble-followups,\n.bubble-updates,\n.bubble-requested-fields {\n  border-color: @border;\n  border-radius: @radius;\n  background: #f7faff;\n}\n\n.bubble-followup-link,\n.bubble-collapsible-toggle {\n  color: @primary;\n\n  &:hover {\n    color: @primary-hover;\n  }\n}\n\n.field-badge,\n.bubble-update-chip,\n.bubble-requested-chip {\n  border-color: #c8d9ed;\n  border-radius: 999px;\n  color: #31557f;\n  background: #edf5ff;\n}\n\n.field-badge.required {\n  border-color: #ffd2d8;\n  color: #b72b3e;\n  background: #fff0f2;\n}\n\n.field-badge.clarify {\n  border-color: #f8db9c;\n  color: #8b5a08;\n  background: #fff8e8;\n}\n\n.bubble-debug-toggle {\n  color: @muted;\n\n  &:hover {\n    color: @primary;\n  }\n}\n\n.bubble-debug-panel,\n.bubble-debug-block pre {\n  border: 1px solid @border;\n  border-radius: @radius;\n  background: #f5f8fc;\n}\n\n.survey-panel-side {\n  .sd-root-modern {\n    --sjs-primary-backcolor: @primary;\n    --sjs-primary-backcolor-dark: @primary-hover;\n    --sjs-primary-backcolor-light: #e9f3ff;\n    --sjs-general-backcolor: @surface;\n    --sjs-general-forecolor: @text;\n    --sjs-secondary-backcolor: @sky;\n    --sjs-border-default: @border;\n    --sjs-font-family: var(--font);\n    --sjs-base-unit: 6px;\n    --sd-base-padding: 5px;\n    --sd-base-vertical-padding: 8px;\n    --sd-page-vertical-padding: 8px;\n  }\n\n  .field-highlight {\n    outline-color: @primary;\n    box-shadow: 0 0 0 4px fade(@primary, 12%);\n  }\n}\n\n.submit-review {\n  margin-top: 24px;\n}\n\n.submit-review-title {\n  color: @text;\n  font-size: 1.05rem;\n}\n\n.review-card {\n  border-color: @border;\n  border-radius: @radius-lg;\n  box-shadow: 0 5px 18px fade(@navy, 5%);\n}\n\n.contact-item {\n  border-color: @border;\n  border-radius: @radius;\n  background: #f8fbff;\n}\n\n.contact-input {\n  border-color: #c5d4e4;\n  border-radius: @radius;\n\n  &:focus {\n    outline: none;\n    border-color: @primary;\n    box-shadow: 0 0 0 3px fade(@primary, 14%);\n  }\n}\n\n.contact-note {\n  color: #225c9b;\n  background: #e5f1ff;\n}\n\n.attachment-confirm,\n.review-card.attachment-confirm {\n  border-color: #b7d7f7;\n  border-radius: @radius-lg;\n  background: #eef7ff;\n}\n\n.attachment-confirm-title,\n.attachment-note {\n  color: @navy;\n}\n\n.attachment-check {\n  background: #18833d;\n}\n\n@media (max-width: 960px) {\n  .smart-form-panel--floating {\n    position: relative !important;\n    inset: auto !important;\n    width: 100% !important;\n    height: min(560px, 72vh) !important;\n    min-width: 0;\n    margin-bottom: 1rem;\n  }\n\n  .chat-panel-title {\n    cursor: default;\n  }\n\n  .chat-panel-drag-handle,\n  .chat-panel-resize-handle {\n    display: none;\n  }\n\n  .survey-panel-side {\n    padding: 0.5rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .smart-form-panel--floating {\n    height: min(500px, 68vh) !important;\n  }\n\n  .chat-compose-row {\n    gap: 6px;\n  }\n\n  .contact-item {\n    gap: 8px;\n  }\n\n  .contact-fields {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n\n  .contact-input {\n    width: 100%;\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
